export const jobPositionsEn = {
  jobCategories: {
    'Others': 'Others',
    'administration': 'Administration',
    'automotive_industry': 'Automotive industry',
    'other_manufacturing': 'Other manufacturing industries',
    'banking_leasing_insurance': 'Banking, leasing and insurance',
    'civil_protection_security': 'Civil protection and security',
    'auxiliary_work_temp_jobs': 'Auxiliary work and temporary jobs',
    'tourism_hospitality': 'Tourism, gastronomy, hospitality',
    'chemical_industry': 'Chemical industry',
    'transport_logistics': 'Freight forwarding, transport and logistics',
    'wood_processing': 'Wood processing industry',
    'economics_finance_accounting': 'Economics, finance, accounting',
    'electrical_engineering_energy': 'Electrical engineering and energy',
    'it_hardware': 'IT - hardware',
    'it_software': 'IT - software',
    'it_system_administration': 'IT - system administration',
    'human_resources': 'Human resources and personnel',
    'quality_management': 'Quality management',
    'marketing_advertising_pr': 'Marketing, advertising, PR',
    'sales': 'Sales',
    'agriculture_forestry': 'Agriculture and forestry',
    'food_industry': 'Food industry',
    'law_legislation': 'Law and legislation',
    'translation_interpretation': 'Translation and interpretation',
    'education': 'Education',
    'services': 'Services',
    'social_services': 'Social services',
    'public_administration': 'Public administration',
    'real_estate_construction': 'Real estate and construction',
    'engineering_technology': 'Engineering, technology and development',
    'telecommunications': 'Telecommunications',
    'textile_clothing_industry': 'Textile, leather and clothing industry',
    'art_culture': 'Art and culture',
    'science_research': 'Science and research',
    'environment_water_management': 'Environment and water management',
    'top_management': 'Top management',
    'production': 'Production',
    'customer_support': 'Customer support',
    'healthcare_pharmacy': 'Healthcare and pharmacy',
    'media_journalism': 'Media and journalism'
  },
  jobPositions: {
    'Others': 'Others',
    'administrative_assistant': 'Administrative worker',
    'online_store_administrator': 'E-commerce administrator',
    'archivist': 'Archivist',
    'assistant': 'Assistant',
    'office_manager': 'Office manager',
    'car_wash_worker': 'Car wash worker',
    'receptionist': 'Receptionist',
    'officer': 'Officer',
    'sales_officer': 'Sales officer',
    'registry_management_officer': 'Registry management officer',
    'contract_management_officer': 'Contract management officer',
    'secretary': 'Secretary',
    'technical_administrative_worker': 'Technical-administrative worker',
    'phone_operator': 'Phone operator',
    'car_upholsterer': 'Car upholsterer',
    'auto_electrician': 'Auto electrician',
    'auto_body_repair_specialist': 'Auto body repair specialist',
    'automotive_designer': 'Automotive designer',
    'auto_mechanic': 'Auto mechanic',
    'auto_glass_technician': 'Auto glass technician',
    'electromechanic': 'Electromechanic',
    'maintenance_engineer': 'Maintenance engineer',
    'inspector': 'Inspector',
    'painter_lacquerer': 'Painter, lacquerer',
    'production_operator': 'Production operator',
    'tire_service_worker': 'Tire service worker',
    'service_technician': 'Service technician',
    'process_engineer': 'Process engineer',
    'automotive_product_manager': 'Product manager in automotive industry',
    'automotive_project_manager': 'Project manager in automotive industry',
    'technologist': 'Technologist',
    'service_manager': 'Service manager',
    'miner': 'Miner',
    'mining_technician': 'Mining technician',
    'metallurgist': 'Metallurgist',
    'metallurgical_engineer': 'Metallurgical engineer',
    'designer': 'Designer',
    'account_manager': 'Account manager',
    'back_office_specialist': 'Back office specialist',
    'compliance_specialist': 'Compliance specialist',
    'custody_specialist': 'Custody specialist',
    'dealer_trader': 'Dealer trader',
    'financial_analyst': 'Financial analyst',
    'financial_controller': 'Financial controller',
    'financial_advisor': 'Financial advisor',
    'mortgage_advisor': 'Mortgage advisor',
    'investment_advisor': 'Investment advisor',
    'client_advisor': 'Client advisor',
    'leasing_advisor': 'Leasing advisor',
    'insurance_claim_appraiser': 'Insurance claim appraiser',
    'insurance_liquidator': 'Insurance liquidator',
    'actuary': 'Actuary',
    'insurance_technician': 'Insurance technician',
    'insurance_advisor': 'Insurance advisor',
    'cashier': 'Cashier',
    'treasury_payment_operations_worker': 'Treasury/payment operations worker',
    'teller': 'Teller',
    'private_banker': 'Private banker',
    'product_manager': 'Product manager',
    'project_manager': 'Project manager',
    'payment_cards_officer': 'Payment cards officer',
    'receivables_management_officer': 'Receivables management officer',
    'insurance_management_officer': 'Insurance management officer',
    'premium_collection_officer': 'Premium collection officer',
    'branch_manager': 'Branch manager',
    'risk_analyst': 'Risk analyst',
    'risk_manager': 'Risk manager',
    'risk_specialist': 'Risk specialist',
    'insurance_payer_control_specialist': 'Insurance payer control specialist',
    'underwriter': 'Underwriter',
    'credit_officer': 'Credit officer',
    'head_of_leasing_department': 'Head of leasing department',
    'department_manager': 'Department manager',
    'security_manager': 'Security manager',
    'security_technician': 'Security technician',
    'firefighter_rescuer': 'Firefighter, rescuer',
    'security_service_manager': 'Security service manager',
    'police_officer': 'Police officer',
    'fire_safety_technician': 'Fire safety technician',
    'security_service_worker': 'Security service worker',
    'guard_service_worker': 'Guard service worker',
    'security_service_director': 'Security service director',
    'health_safety_technician': 'Health and safety technician',
    'fire_protection_technician': 'Fire protection technician',
    'prison_guard': 'Prison guard',
    'soldier': 'Soldier',
    'surveyor': 'Surveyor',
    'temporary_worker': 'Temporary worker',
    'helper': 'Helper',
    'laborer': 'Laborer',
    'cleaner': 'Cleaner',
    'porter': 'Porter',
    'leisure_animator': 'Leisure animator',
    'barista': 'Barista',
    'bartender': 'Bartender',
    'waiter': 'Waiter',
    'housekeeper': 'Housekeeper',
    'concierge': 'Concierge',
    'confectioner': 'Confectioner',
    'f_b_manager': 'F&B manager',
    'facility_manager': 'Facility manager',
    'front_desk_manager': 'Front desk manager',
    'hostess': 'Hostess',
    'croupier': 'Croupier',
    'cook': 'Cook',
    'hotel_manager': 'Hotel manager',
    'hotel_pension_sales_department_manager': 'Hotel/pension sales department manager',
    'butcher': 'Butcher',
    'baker': 'Baker',
    'pizza_maker': 'Pizza maker',
    'lifeguard': 'Lifeguard',
    'kitchen_helper': 'Kitchen helper',
    'assistant_cook': 'Assistant cook',
    'fast_food_worker': 'Fast food worker',
    'ticket_seller': 'Ticket seller',
    'travel_agent': 'Travel agent',
    'operations_manager': 'Operations manager',
    'chef': 'Chef',
    'sommelier': 'Sommelier',
    'tourist_guide': 'Tourist guide',
    'steward_flight_attendant': 'Steward, flight attendant',
    'facility_operations_manager': 'Facility manager',
    'chemical_engineer': 'Chemical engineer',
    'chemical_laboratory_technician': 'Chemical laboratory technician',
    'chemist': 'Chemist',
    'chemical_industry_machinery_operator': 'Chemical industry machinery operator',
    'chemical_industry_technologist': 'Chemical industry technologist',
    'customs_declarant': 'Customs declarant',
    'dispatcher': 'Dispatcher',
    'scheduler': 'Scheduler',
    'transportation_engineer': 'Transportation engineer',
    'shipping_clerk': 'Shipping clerk',
    'ship_captain': 'Ship captain',
    'logistics_transport_supply_controller': 'Logistics, transport and supply controller',
    'coordinator': 'Coordinator',
    'courier': 'Courier',
    'logistician': 'Logistician',
    'logistics_manager': 'Logistics manager',
    'fleet_manager': 'Fleet manager',
    'buyer': 'Buyer',
    'postal_carrier': 'Postal carrier',
    'shipping_worker': 'Shipping worker',
    'transport_project_manager': 'Transport project manager',
    'logistics_director': 'Logistics director',
    'train_driver': 'Train driver',
    'warehouse_worker': 'Warehouse worker',
    'freight_forwarder': 'Freight forwarder',
    'transport_manager': 'Transport manager',
    'purchasing_manager': 'Purchasing manager',
    'sales_department_manager': 'Sales manager',
    'post_office_manager': 'Post office manager',
    'warehouse_manager': 'Warehouse manager',
    'bus_driver': 'Bus driver',
    'truck_driver': 'Truck driver',
    'public_transport_driver': 'Public transport driver',
    'truck_driver_cargo': 'Truck driver',
    'car_driver': 'Car driver',
    'forklift_driver': 'Forklift driver',
    'stationmaster': 'Stationmaster',
    'train_dispatcher': 'Dispatcher',
    'supplier': 'Supplier',
    'delivery_driver': 'Delivery driver',
    'upholsterer': 'Upholsterer',
    'wood_engineer': 'Wood engineer',
    'wood_technician': 'Wood technician',
    'furniture_designer': 'Designer',
    'furniture_maker': 'Furniture maker',
    'sawyer': 'Sawyer',
    'wood_processing_industry_designer': 'Wood processing industry designer',
    'carpenter': 'Carpenter',
    'audit_assistant': 'Audit assistant',
    'auditor': 'Auditor',
    'broker': 'Broker',
    'tax_advisor': 'Tax advisor',
    'economist': 'Economist',
    'invoice_clerk': 'Invoice clerk',
    'financial_agent': 'Financial agent',
    'financial_manager': 'Financial manager',
    'chief_financial_officer': 'Chief financial officer',
    'fundraiser': 'Fundraiser',
    'chief_accountant': 'Chief accountant',
    'mortgage_specialist': 'Mortgage specialist',
    'consultant': 'Consultant',
    'eu_projects_coordinator': 'EU projects coordinator',
    'payroll_accountant': 'Payroll accountant',
    'business_analyst': 'Business analyst',
    'personal_banker': 'Personal banker',
    'payment_operations_worker': 'Payment operations worker',
    'settlement_officer': 'Settlement officer',
    'head_of_economic_department': 'Head of economic department',
    'budget_planner_calculator': 'Budget planner, calculator',
    'invoicing_payments_specialist': 'Invoicing and payments specialist',
    'financial_markets_specialist': 'Financial markets specialist',
    'receivables_specialist': 'Receivables specialist',
    'reporting_specialist': 'Reporting specialist',
    'statistician': 'Statistician',
    'accountant': 'Accountant',
    'credit_specialist': 'Credit specialist',
    'electrician': 'Electrician',
    'electrical_installer': 'Electrical installer',
    'electronics_technician': 'Electronics technician',
    'electrical_engineer': 'Electrical engineer',
    'electrical_technician': 'Electrical technician',
    'energy_specialist': 'Energy specialist',
    'simulation_engineer': 'Simulation engineer',
    'integrated_circuit_designer': 'Integrated circuit designer',
    'aircraft_mechanic': 'Aircraft mechanic',
    'refrigeration_equipment_mechanic': 'Refrigeration equipment mechanic',
    'mechatronics_specialist': 'Mechatronics specialist',
    'energy_equipment_operator': 'Energy equipment operator',
    'repairman': 'Repairman',
    'lighting_technician': 'Lighting technician',
    'electrical_engineering_project_manager': 'Electrical engineering project manager',
    'energy_project_manager': 'Energy project manager',
    'inspection_technician': 'Inspection technician',
    'service_engineer': 'Service engineer',
    'electrical_service_technician': 'Service technician',
    'test_technician': 'Test technician',
    'network_strategy_specialist': 'Network strategy specialist',
    'system_engineer': 'System engineer',
    'technical_inspection_technician': 'Technical inspection technician',
    'technical_manager': 'Technical manager',
    'technician': 'Technician',
    'sound_engineer': 'Sound engineer',
    'telecommunications_network_designer': 'Telecommunications network designer',
    'computer_technician': 'Computer technician',
    'industrial_robot_programmer': 'Industrial robot programmer',
    'transmission_network_analysis_development_specialist': 'Transmission network analysis and development specialist',
    'abap_programmer': 'ABAP programmer',
    'android_programmer': 'Android programmer',
    'backend_developer': 'Back-end programmer',
    'business_intelligence_specialist': 'Business Intelligence Specialist',
    'c_programmer': 'C programmer',
    'crm_specialist': 'CRM specialist',
    'database_analyst': 'Database analyst',
    'database_specialist': 'Database specialist',
    'devops_engineer': 'DevOps Engineer',
    'front_end_programmer': 'Front-end programmer',
    'help_desk_worker': 'Help desk worker',
    'ios_programmer': 'iOS programmer',
    'it_analyst': 'IT analyst',
    'it_architect': 'IT architect',
    'it_consultant': 'IT consultant',
    'it_product_manager': 'IT product manager',
    'it_project_manager': 'IT project manager',
    'it_director': 'IT director',
    'it_tester': 'IT tester',
    'java_programmer': 'Java programmer',
    'javascript_programmer': 'Javascript programmer',
    'net_programmer': '.NET programmer',
    'objective_c_programmer': 'Objective-C programmer',
    'oracle_programmer': 'Oracle programmer',
    'perl_programmer': 'Perl programmer',
    'php_programmer': 'PHP programmer',
    'plc_programmer': 'PLC programmer',
    'junior_programmer': 'Junior programmer',
    'sales_support_worker': 'Sales support worker',
    'programmer': 'Programmer',
    'python_programmer': 'Python programmer',
    'sap_product_manager': 'SAP Product Manager',
    'sap_specialist': 'SAP Specialist',
    'scrum_master': 'Scrum Master',
    'software_engineer': 'Software engineer',
    'end_device_testing_specialist': 'End device testing specialist',
    'technical_writer': 'Technical writer',
    'user_experience_expert': 'User Experience Expert',
    'webmaster': 'Webmaster',
    'ict_specialist': 'ICT specialist',
    'it_technical_support_specialist': 'IT/Technical Support Specialist',
    'network_modeling_specialist': 'Network modeling specialist',
    'it_security_specialist': 'IT security specialist',
    'fraud_prevention_specialist': 'Fraud prevention specialist',
    'information_system_administrator': 'Information system administrator',
    'network_administrator': 'Network administrator',
    'system_administrator': 'System administrator',
    'hr_assistant': 'HR assistant',
    'hr_business_partner': 'HR Business Partner',
    'hr_generalist': 'HR Generalist',
    'hr_coordinator': 'HR Coordinator',
    'lecturer_trainer': 'Lecturer, trainer',
    'human_resources_manager': 'Human resources manager',
    'hr_specialist': 'HR specialist',
    'personnel_consultant': 'Personnel consultant',
    'personnel_manager': 'Personnel manager',
    'hr_director': 'HR director',
    'work_psychologist': 'Work psychologist',
    'psychologist': 'Psychologist',
    'recruiter_selection_specialist': 'Recruiter, selection specialist',
    'head_of_hr_department': 'Head of HR department, HR director',
    'compensation_specialist': 'Compensation specialist',
    'training_education_specialist': 'Training and education specialist',
    'quality_inspector': 'Inspector',
    'quality_engineer': 'Quality engineer',
    'quality_controller': 'Quality controller',
    'quality_manager': 'Quality manager',
    'quality_planner': 'Quality planner',
    'quality_iso_director': 'Quality and ISO director',
    'iso_specialist': 'ISO specialist',
    'brand_manager': 'Brand manager',
    'copywriter': 'Copywriter',
    'dtp_operator': 'DTP operator',
    'event_manager': 'Event manager',
    'graphic_designer': 'Graphic designer',
    'graphic_artist': 'Graphic artist',
    'spokesperson': 'Spokesperson',
    'complaints_department_manager': 'Complaints department manager',
    'marketing_manager': 'Marketing manager',
    'marketing_worker': 'Marketing worker',
    'marketing_director': 'Marketing director',
    'marketing_specialist': 'Marketing specialist',
    'multimedia_specialist': 'Multimedia Specialist',
    'ppc_specialist': 'PPC specialist',
    'pr_manager': 'PR manager',
    'advertising_marketing_product_manager': 'Product manager in advertising and marketing',
    'marketing_project_manager': 'Marketing project manager',
    'market_research_project_manager': 'Market research project manager',
    'promoter': 'Promoter',
    'creative_director': 'Creative director',
    'seo_analyst': 'SEO analyst',
    'internal_communication_specialist': 'Internal communication specialist',
    'marketing_analysis_specialist': 'Marketing analysis specialist',
    'visual_merchandiser': 'Visual merchandiser',
    'relationship_manager': 'Relationship manager',
    'web_designer': 'Web designer',
    'inventory_commission_member': 'Inventory commission member',
    'country_manager_director': 'Country manager / director',
    'demand_planner': 'Demand planner',
    'merchandiser_stock_assistant': 'Merchandiser',
    'merchandiser': 'Merchandiser',
    'e_commerce_specialist': 'E-commerce specialist',
    'key_account_manager': 'Key account manager',
    'store_branch_manager': 'Store/branch manager',
    'salesperson': 'Salesperson',
    'sales_manager': 'Sales manager',
    'sales_representative_officer': 'Sales officer',
    'sales_director': 'Sales director',
    'sales_representative': 'Sales representative',
    'specialist_salesperson': 'Specialist salesperson',
    'complaints_department_worker': 'Complaints department worker',
    'pyrotechnics_seller': 'Pyrotechnics seller',
    'team_leader': 'Team leader',
    'shop_assistant': 'Shop assistant',
    'retail_operations_manager': 'Operations manager',
    'regional_area_manager': 'Regional / Area manager',
    'telemarketing_worker': 'Telemarketing worker',
    'sales_team_manager': 'Sales team manager',
    'store_facility_manager': 'Store/facility manager',
    'complaints_department_head': 'Complaints department manager',
    'store_section_manager': 'Store section manager',
    'deputy_store_facility_manager': 'Deputy store/facility manager',
    'agronomist': 'Agronomist',
    'animal_breeder_caretaker': 'Animal breeder, caretaker',
    'milker': 'Milker',
    'forester': 'Forester',
    'forest_engineer': 'Forest engineer',
    'forest_technician': 'Forest technician',
    'soil_scientist': 'Soil scientist',
    'agricultural_engineer_agronomist': 'Agricultural engineer, agronomist',
    'agricultural_technician': 'Agricultural technician',
    'agricultural_technologist': 'Agricultural technologist',
    'cooperative_chairman': 'Cooperative chairman',
    'farmer': 'Farmer',
    'tractor_combine_operator': 'Tractor/combine operator',
    'veterinary_assistant': 'Veterinary assistant',
    'veterinarian': 'Veterinarian',
    'gardener': 'Gardener',
    'landscape_architect': 'Landscape architect',
    'picker': 'Picker',
    'zootechnician': 'Zootechnician',
    'food_engineer': 'Food engineer',
    'food_technician': 'Food technician',
    'food_technologist': 'Food technologist',
    'trainee_lawyer': 'Trainee lawyer',
    'bailiff': 'Bailiff',
    'bailiff_trainee': 'Bailiff trainee',
    'registrar': 'Registrar',
    'notary': 'Notary',
    'notary_trainee': 'Notary trainee',
    'paralegal_law_student': 'Paralegal – law student',
    'lawyer': 'Lawyer',
    'legal_assistant': 'Legal assistant',
    'regulatory_affairs_manager': 'Regulatory affairs manager',
    'regulatory_affairs_specialist': 'Regulatory affairs specialist',
    'enforcement_specialist': 'Enforcement specialist',
    'judge': 'Judge',
    'court_expert': 'Court expert',
    'head_of_legal_department': 'Head of legal department',
    'proofreader': 'Proofreader',
    'translation_agency_business_manager': 'Translation agency business manager',
    'translator': 'Translator',
    'interpreter': 'Interpreter',
    'teaching_assistant': 'Teaching assistant',
    'phd_student': 'PhD student',
    'driving_instructor': 'Driving instructor',
    'speech_therapist': 'Speech therapist',
    'vocational_education_master': 'Vocational education master',
    'professor': 'Professor',
    'school_principal': 'School principal',
    'school_caretaker': 'School caretaker',
    'social_worker': 'Social worker',
    'special_education_teacher': 'Special education teacher',
    'sports_coach': 'Sports coach',
    'primary_school_teacher_grades_1_4': 'Primary school teacher (grades 1-4)',
    'primary_school_teacher_grades_5_9': 'Primary school teacher (grades 5-9)',
    'secondary_school_teacher': 'Secondary school teacher',
    'university_teacher': 'University teacher',
    'kindergarten_teacher': 'Kindergarten teacher',
    'educator': 'Educator',
    'florist_decorator': 'Florist decorator',
    'au_pair': 'Au-pair',
    'coach': 'Coach',
    'photographer': 'Photographer',
    'house_keeper': 'Housekeeper',
    'watchmaker': 'Watchmaker',
    'houseman': 'Houseman',
    'plumber': 'Plumber',
    'interior_designer': 'Interior designer',
    'hairdresser': 'Hairdresser',
    'fitness_trainer': 'Fitness trainer',
    'blacksmith': 'Blacksmith',
    'beautician': 'Beautician',
    'stoker': 'Stoker',
    'florist': 'Florist',
    'painter': 'Painter',
    'gas_station_attendant': 'Gas station attendant',
    'wedding_planner': 'Wedding planner',
    'pedicurist_manicurist': 'Pedicurist, manicurist',
    'stylist_makeup_artist': 'Stylist, makeup artist',
    'maintenance_worker': 'Maintenance worker',
    'goldsmith_jeweler': 'Goldsmith, jeweler',
    'caregiver': 'Caregiver',
    'professional_parent': 'Professional parent',
    'customs_officer': 'Customs officer',
    'general_state_advisor': 'General state advisor',
    'chief_advisor': 'Chief advisor',
    'chief_officer': 'Chief officer',
    'chief_state_advisor': 'Chief state advisor',
    'expert_advisor': 'Expert advisor',
    'expert_officer': 'Expert officer',
    'advisor': 'Advisor',
    'department_director': 'Department director',
    'independent_advisor': 'Independent advisor',
    'independent_officer': 'Independent officer',
    'public_procurement_specialist': 'Public procurement specialist',
    'professional_soldier': 'Professional soldier',
    'state_administration_employee': 'State administration employee',
    'public_administration_employee': 'Public administration employee',
    'architect': 'Architect',
    'interior_architect': 'Interior architect',
    'geologist': 'Geologist',
    'insulation_worker': 'Insulation worker',
    'tinsmith_roofer': 'Tinsmith, roofer',
    'scaffolder': 'Scaffolder',
    'installer': 'Installer',
    'mason_tiler': 'Mason, tiler',
    'real_estate_appraiser': 'Real estate appraiser',
    'window_installer_glazier': 'Window installer, glazier',
    'construction_machinery_operator': 'Construction machinery operator',
    'floor_layer_paver': 'Floor layer, paver',
    'pipe_fitter': 'Pipe fitter',
    'hvac_worker': 'HVAC worker',
    'industrial_climber': 'Industrial climber',
    'construction_planner': 'Construction planner',
    'mep_designer': 'MEP designer',
    'construction_project_manager': 'Construction project manager',
    'real_estate_agent': 'Real estate agent',
    'construction_estimator': 'Construction estimator',
    'drywall_installer': 'Drywall installer',
    'building_manager': 'Building manager',
    'structural_engineer': 'Structural engineer',
    'construction_supervisor': 'Construction supervisor',
    'civil_engineer': 'Civil engineer',
    'construction_foreman': 'Construction foreman',
    'construction_technician': 'Construction technician',
    'construction_locksmith': 'Construction locksmith',
    'construction_carpenter': 'Carpenter',
    'locksmith': 'Locksmith',
    'land_surveyor': 'Surveyor',
    'crane_operator': 'Crane operator',
    'welder': 'Welder',
    'grinder': 'Grinder',
    'cad_designer': 'CAD designer',
    'cnc_programmer': 'CNC programmer',
    'milling_machine_operator_turner': 'Milling machine operator, turner',
    'metal_worker': 'Metal worker',
    'engineering_machinery_operator': 'Engineering machinery operator',
    'process_manager': 'Process manager',
    'engineering_project_manager': 'Engineering project manager',
    'machinist': 'Machinist',
    'mechanical_engineer': 'Mechanical engineer',
    'mechanical_technician': 'Mechanical technician',
    'mechanical_locksmith': 'Mechanical locksmith',
    'technical_worker': 'Technical worker',
    'technical_process_engineer': 'Technical process engineer',
    'technical_designer': 'Technical designer',
    'technical_project_manager': 'Technical project manager',
    'technical_director': 'Technical director',
    'non_destructive_testing_technician': 'Non-destructive testing technician',
    'head_of_technical_department': 'Head of technical department',
    'call_center_manager': 'Call center manager',
    'is_product_manager': 'IS product manager',
    'telecommunications_project_manager': 'Telecommunications project manager',
    'call_center_director': 'Call center director',
    'oss_bss_specialist': 'OSS/BSS specialist',
    'radio_network_planning_specialist': 'Radio network planning specialist',
    'network_services_operations_specialist': 'Network and services operations specialist',
    'radio_network_optimization_specialist': 'Radio network optimization specialist',
    'mobile_network_development_specialist': 'Mobile network development specialist',
    'communication_systems_specialist': 'Communication systems specialist',
    'telecommunications_product_development_specialist': 'Telecommunications product development specialist',
    'telecommunications_services_development_specialist': 'Telecommunications services development specialist',
    'call_center_supervisor': 'Call center supervisor',
    'telecommunications_technical_worker': 'Telecommunications technical worker',
    'customer_service': 'Customer service',
    'furrier': 'Furrier',
    'tailor_seamstress': 'Tailor, seamstress',
    'shoemaker': 'Shoemaker',
    'fashion_designer': 'Fashion designer',
    'clothing_industry_machinery_operator': 'Clothing industry machinery operator',
    'cutter': 'Cutter',
    'creative_designer': 'Designer',
    'cameraman_editor': 'Cameraman, editor',
    'cultural_officer': 'Cultural officer',
    'makeup_artist_wig_maker': 'Makeup artist, wig maker',
    'fashion_stylist': 'Fashion designer',
    'set_designer': 'Set designer',
    'singer_actor_musician': 'Singer, actor, musician',
    'dancer_choreographer': 'Dancer, choreographer',
    'art_designer': 'Art designer',
    'art_photographer': 'Art photographer',
    'art_painter': 'Art painter',
    'cultural_institution_employee': 'Cultural institution employee',
    'biologist': 'Biologist',
    'research_chemist': 'Chemist',
    'physicist': 'Physicist',
    'librarian': 'Librarian',
    'laboratory_technician': 'Laboratory technician',
    'metrologist': 'Metrologist',
    'microbiologist': 'Microbiologist',
    'sociologist': 'Sociologist',
    'research_scientific_worker': 'Research and scientific worker',
    'ecologist_environmentalist': 'Ecologist, environmentalist',
    'environmentalist': 'Environmentalist',
    'geodesist': 'Geodesist',
    'water_management_engineer': 'Water management engineer',
    'water_management_technician': 'Water management technician',
    'country_director_manager': 'Country director, manager',
    'ceo': 'CEO',
    'executive_director': 'Executive director',
    'packer': 'Packer',
    'production_foreman': 'Production foreman',
    'assembler': 'Assembler',
    'cnc_machine_setter': 'CNC machine setter',
    'machine_setter': 'Machine setter',
    'tool_maker': 'Tool maker',
    'work_standards_specialist': 'Work standards specialist',
    'machine_operator': 'Machine operator',
    'production_planner': 'Production planner',
    'maintenance_manager': 'Maintenance manager',
    'production_director': 'Production director',
    'foundry_worker': 'Foundry worker',
    'client_service_worker': 'Client service worker',
    'customer_service_manager': 'Customer service manager',
    'help_desk_support_worker': 'Help desk worker',
    'customer_support_specialist': 'Customer support specialist',
    'nutrition_assistant': 'Nutrition assistant',
    'dental_hygienist': 'Dental hygienist',
    'home_caregiver': 'Home caregiver',
    'drug_safety_specialist': 'Drug Safety Specialist',
    'pharmacist': 'Pharmacist',
    'pharmaceutical_laboratory_technician': 'Pharmaceutical laboratory technician',
    'physiotherapist': 'Physiotherapist',
    'head_nurse': 'Head nurse',
    'hygienist': 'Hygienist',
    'laboratory_diagnostician': 'Laboratory diagnostician',
    'doctor': 'Doctor',
    'masseur': 'Masseur',
    'medical_advisor': 'Medical advisor',
    'medical_pharmaceutical_representative': 'Medical/pharmaceutical representative',
    'clinical_trial_monitor': 'Clinical trial monitor',
    'optician': 'Optician',
    'optometrist': 'Optometrist',
    'orthopedic_technician': 'Orthopedic technician',
    'midwife': 'Midwife',
    'healthcare_product_manager': 'Healthcare product manager',
    'healthcare_project_manager': 'Healthcare project manager',
    'radiologist': 'Radiologist',
    'radiology_assistant': 'Radiology assistant',
    'audit_nurse': 'Audit nurse',
    'audit_pharmacist': 'Audit pharmacist',
    'audit_doctor': 'Audit doctor',
    'healthcare_facility_director': 'Healthcare facility director',
    'orderly': 'Orderly',
    'nurse': 'Nurse',
    'medicine_warehouse_worker': 'Medicine warehouse worker',
    'healthcare_purchasing_specialist': 'Healthcare purchasing specialist',
    'health_program_development_specialist': 'Health program development specialist',
    'support_health_activities_specialist': 'Support and health activities specialist',
    'public_health_specialist': 'Public health specialist',
    'senior_nurse': 'Head nurse',
    'registered_nurse': 'Nurse',
    'medical_laboratory_technician': 'Medical laboratory technician',
    'paramedic': 'Paramedic',
    'healthcare_assistant': 'Healthcare assistant',
    'dental_assistant': 'Dental assistant',
    'dental_laboratory_technician': 'Dental laboratory technician',
    'dentist': 'Dentist',
    'dental_technician': 'Dental technician',
    'editor': 'Editor',
    'editor_in_chief': 'Editor-in-chief',
    'bookbinder': 'Bookbinder',
    'advertising_manager': 'Advertising manager',
    'media_buyer': 'Media buyer',
    'media_planner': 'Media planner',
    'journalist': 'Journalist',
    'producer': 'Producer',
    'production_manager': 'Production manager',
    'editorial_writer': 'Editor',
    'publishing_director': 'Publishing director',
    'chief_editor': 'Chief editor',
    'social_media_specialist': 'Social media specialist',
    'printer': 'Printer',
    'deputy_editor': 'Deputy editor'
  }
};